import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';
import { ZoneService } from '../proxy/planning/controllers/zone.service';
import { LocationService } from '../proxy/planning/controllers/location.service';

FieldBuilder.setNamespace('Planning');

export const OFFICE_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.Office.Name')
    .required()
    .minLength(1)
    .maxLength(100)
    .build(),
  FieldBuilder
    .foreignKey('zoneId', 'Entity.Zone', ZoneService)
    .required()
    .displayFromNested('zone.name')
    .sortBy('zone.name')
    .build(),
  FieldBuilder
    .foreignKey('locationId', 'Entity.Location', LocationService)
    .required()
    .displayFromNested('location.name')
    .sortBy('location.name')
    .hideInChildForms()
    .build(),
];

export const OFFICE_CONFIG = {
  entityName: 'Office',
  localizationKey: 'Planning::Entity.Office',
  permission: 'PlanningLocation.Offices',
  fields: OFFICE_FIELDS,

  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Planning + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Location + MENU_NAME_SUFFIX,
};
